module.exports = __webpack_public_path__ + "27499a27f8ef08a167753731e1d91368.MP3";